/* eslint-disable import/prefer-default-export */
export function hashCode(hashLength) {
  return Array.from(Array(Number(hashLength) || 24), () => Math.floor(Math.random() * 36).toString(36)).join('') + Date.now();
}
